import api from 'services/api';
import { POST, emailRoutes, GET, unsubscribeRoutes } from 'constants/api';

export const unSubscribeManual = data =>
  api({
    method: POST,
    url: emailRoutes.UNSUBSCRIBE_MANUAL,
    data,
  });

export const reSubscribeManual = data =>
  api({
    method: POST,
    url: emailRoutes.RE_SUBSCRIBE_MANUAL,
    data,
  });

export const unsubscribeOrganization = data =>
  api({
    method: POST,
    url: emailRoutes.UNSUBSCRIBE_ORGANIZATION,
    data,
  });

export const unsubscribeOrganizationEmailCount = data =>
  api({
    method: POST,
    url: emailRoutes.UNSUBSCRIBE_ORGANIZATION_EMAIL_COUNT,
    data,
  });

export const resubscribeOrganization = data =>
  api({
    method: POST,
    url: emailRoutes.RE_SUBSCRIBE_ORGANIZATION,
    data,
  });

export const getUnsubscribedDomains = () =>
  api({
    method: GET,
    url: emailRoutes.UNSUBSCRIBED_DOMAINS,
  });
export const getUnsubscribedEmails = email =>
  api({
    method: GET,
    url: `${emailRoutes.UNSUBSCRIBED_EMAILS}${email}`,
  });

export const validateBulkUnsubscribe = (data: Object) =>
  api({
    method: POST,
    url: `${emailRoutes.VALIDATE_BULK_UNSUBSCRIBE}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const bulkUnsubscribe = (data: Object) =>
  api({
    method: POST,
    url: `${emailRoutes.BULK_UNSUBSCRIBE}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const listUnsubscriptions = (params: Object) =>
  api({
    method: GET,
    url: `${emailRoutes.LISTING_UNSUBSCRIPTION}`,
    params,
  });

export const countUnsubscriptions = (params: Object) =>
  api({
    method: GET,
    url: `${emailRoutes.COUNT_UNSUBSCRIPTION}`,
    params,
  }).then(data => data.count);

export const getUnsubscriptionStatus = (token: string) => {
  return api({
    method: GET,
    withoutAuthorization: true,
    url: unsubscribeRoutes.GET_UNSUBSCRIPTION_STATUS(token),
  });
};

export const unsubscribePublic = data => {
  return api({
    method: GET,
    withoutAuthorization: true,
    url: unsubscribeRoutes.UNSUBSCRIBE,
    params: data,
  });
};

export const resubscribePublic = data => {
  return api({
    method: GET,
    withoutAuthorization: true,
    url: unsubscribeRoutes.RE_SUBSCRIBE,
    params: data,
  });
};

export const pauseEmailPublic = data => {
  return api({
    method: GET,
    withoutAuthorization: true,
    url: unsubscribeRoutes.PAUSE_EMAILS,
    params: data,
  });
};

export const changePauseDurationPublic = data => {
  return api({
    method: GET,
    withoutAuthorization: true,
    url: unsubscribeRoutes.CHANGE_PAUSE_DURATION,
    params: data,
  });
};

export const saveUnsubscribeReason = data => {
  return api({
    method: POST,
    withoutAuthorization: true,
    url: unsubscribeRoutes.CHANGE_PAUSE_REASON,
    data,
  });
};
